"use client";

import React from 'react';

export default function ChatAgentLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return children;
}
